(function () {
  function setupHeader(header) {
    if (!header || header.dataset.rghReady === 'true') return;
    header.dataset.rghReady = 'true';

    var section = header.closest('.shopify-section');
    var menu = header.querySelector('[data-rgh-menu]');
    var search = header.querySelector('[data-rgh-search]');
    var interactiveDetails = [menu, search].filter(Boolean);

    if (section && header.classList.contains('rgh-header--sticky')) {
      section.classList.add('rgh-section-sticky');
    }

    function setExpanded(details) {
      var summary = details && details.querySelector(':scope > summary');
      if (summary) summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
    }

    function closeDetails(details, restoreFocus) {
      if (!details || !details.open) return;
      details.open = false;
      setExpanded(details);
      if (restoreFocus) {
        var summary = details.querySelector(':scope > summary');
        if (summary) summary.focus();
      }
    }

    interactiveDetails.forEach(function (details) {
      setExpanded(details);

      details.addEventListener('toggle', function () {
        setExpanded(details);

        if (!details.open) return;
        interactiveDetails.forEach(function (other) {
          if (other !== details) closeDetails(other, false);
        });

        if (details === search) {
          var input = search.querySelector('[data-rgh-search-input]');
          if (input) window.requestAnimationFrame(function () { input.focus(); });
        }
      });
    });

    if (menu) {
      menu.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', function () {
          closeDetails(menu, false);
        });
      });
    }

    document.addEventListener('click', function (event) {
      if (header.contains(event.target)) return;
      interactiveDetails.forEach(function (details) {
        closeDetails(details, false);
      });
    });

    header.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      var openDetails = interactiveDetails.find(function (details) { return details.open; });
      if (openDetails) {
        event.preventDefault();
        closeDetails(openDetails, true);
      }
    });
  }

  function setupAll(root) {
    var scope = root || document;
    if (scope.matches && scope.matches('[data-rgh-header]')) setupHeader(scope);
    scope.querySelectorAll('[data-rgh-header]').forEach(setupHeader);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setupAll(document); }, { once: true });
  } else {
    setupAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    setupAll(event.target);
  });
})();
